// extracted by mini-css-extract-plugin
export var checkbox = "_2r-0";
export var circle = "_2r-3";
export var horizontalContainer = "_2r-7";
export var sm = "_2r-5";
export var switch0 = "_2r-2";
export var switchDisabled = "_2r-8";
export var switchEnabled = "_2r-1";
export var textSwitchContainer = "_2r-9";
export var textSwitchOption = "_2r-a";
export var textSwitchOptionSelected = "_2r-b";
export var verticalContainer = "_2r-6";
export var xs = "_2r-4";